import React, { useRef } from "react";
import CardSlider from "./CardSlider";
import { SwiperSlide } from "swiper/react";
import Card from "../Card";
import NavigationButton from "./SliderBtn";

const CourseSlider = ({ data }) => {
  const swiperRef = useRef(null);

  return (
    <div className="m-auto">
      {" "}
      <CardSlider onSwiper={(swiper) => (swiperRef.current = swiper)}>
        {data.map((card, index) => {
          return (
            <SwiperSlide key={index} style={{ width: "fit-content" }}>
              <Card
                combo={card.combo}
                number_of_courses={card.number_of_courses}
                courseName1={card.courseName1}
                courseName2={card.courseName2}
                coursePrice1={card.coursePrice1}
                coursePrice2={card.coursePrice2}
                razorLink={card.razorLink}
                discountPrice={card.discountPrice}
                courseImage1={card.courseImage1}
                courseImage2={card.courseImage2}
              />
            </SwiperSlide>
          );
        })}
           
      </CardSlider>
      {data.length >= 4 && (
        <div>
          <NavigationButton swiperRef={swiperRef} type="prev" />
          <NavigationButton swiperRef={swiperRef} type="right" />
        </div>
      )}
    </div>
  );
};

export default CourseSlider;
